import { Popover, Transition } from '@headlessui/react';
import { Link, NavLink } from 'react-router-dom';
import {
  AnnotationIcon,
  ChatAlt2Icon,
  InboxIcon,
  MenuIcon,
  QuestionMarkCircleIcon,
  XIcon,
} from '@heroicons/react/outline';
import { Fragment, useContext, useRef } from 'react';
import { AuthContext } from '../../containers/AuthProvider';
import firebase from 'firebase/app';
import { useHistory } from 'react-router';

const solutions = [
  {
    name: 'Home',
    description:
      'Get a better understanding of where your traffic is coming from.',
    href: '/',
    icon: InboxIcon,
  },
  {
    name: 'About',
    description: 'Speak directly to your customers in a more meaningful way.',
    href: '/about-us',
    icon: AnnotationIcon,
  },
  {
    name: 'Service',
    description: '',
    href: '/services',
    icon: ChatAlt2Icon,
  },
  {
    name: 'Jobs',
    description: "Your customers' data will be safe and secure.",
    href: '/jobs',
    icon: ChatAlt2Icon,
  },
  {
    name: 'Whats App',
    description: "Connect with third-party tools that you're already using.",
    href: 'https://api.whatsapp.com/send/?phone=971585452848&text=I%27m%20inquiring%20about%20job.',
    icon: QuestionMarkCircleIcon,
  },
  {
    name: 'Contact Us',
    description: "Connect with third-party tools that you're already using.",
    href: '/contact-us',
    icon: QuestionMarkCircleIcon,
  },
];

export function LandingAppBar() {
  const userInfo = useContext(AuthContext);
  const history = useHistory();
  const headerRef = useRef<HTMLDivElement>();
  const onLogout = () => {
    firebase.auth().signOut();
    history.push('/');
  };

  return (
    <>
      <header className="fixed top-0 z-30 w-full" ref={headerRef}>
        <Popover className="relative bg-white">
          {({ open }) => (
            <>
              <div className="flex justify-between items-center max-w-12xl mx-auto px-4 py-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8">
                <div className="flex justify-start lg:w-0 lg:flex-1">
                  <Link to="/">
                    <span className="sr-only">V Recruit</span>
                    <img className="h-16 w-auto" src="/logo.svg" alt="" />
                  </Link>
                </div>
                <div className="-mr-2 -my-2 md:hidden">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                    <span className="sr-only">Open menu</span>
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
                <Popover.Group as="nav" className="hidden md:flex space-x-10">
                  <NavLink
                    to="/"
                    activeStyle={{ fontWeight: 'bolder' }}
                    exact
                    activeClassName="text-blue-900"
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Home
                  </NavLink>

                  <NavLink
                    to="/about-us"
                    activeClassName="text-blue-900"
                    activeStyle={{ fontWeight: 'bolder' }}
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    About Us
                  </NavLink>
                  <NavLink
                    to="/services"
                    activeClassName="text-blue-900"
                    activeStyle={{ fontWeight: 'bolder' }}
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Services
                  </NavLink>
                  <NavLink
                    to="/jobs"
                    activeClassName="text-blue-900"
                    activeStyle={{ fontWeight: 'bolder' }}
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Jobs
                  </NavLink>
                  {!userInfo && (
                    <NavLink
                      to="/sign-in"
                      className="text-base font-medium text-gray-500 hover:text-gray-900"
                    >
                      Candidate
                    </NavLink>
                  )}
                  <a
                    href={`https://api.whatsapp.com/send/?phone=971585452848&text=${encodeURIComponent(
                      "I'm inquiring about job."
                    )}`}
                    target="_blank"
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    WhatsApp
                  </a>
                  <NavLink
                    to="/contact-us"
                    activeClassName="text-blue-900"
                    activeStyle={{ fontWeight: 'bolder' }}
                    className="text-base font-medium text-gray-500 hover:text-gray-900"
                  >
                    Contact US
                  </NavLink>
                  {userInfo && (
                    <NavLink
                      to="/profile"
                      activeClassName="text-blue-900"
                      activeStyle={{ fontWeight: 'bolder' }}
                      className="text-base font-medium text-gray-500 hover:text-gray-900"
                    >
                      Profile
                    </NavLink>
                  )}
                  {userInfo && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        onLogout();
                        history.push('/');
                      }}
                      className="text-base font-medium text-gray-500 hover:text-gray-900"
                    >
                      Sign out
                    </a>
                  )}
                </Popover.Group>
                <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0" />
              </div>

              <Transition
                show={open}
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Popover.Panel
                  focus
                  static
                  className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                >
                  <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                    <div className="pt-5 pb-6 px-5">
                      <div className="flex items-center justify-between">
                        <div>
                          <img
                            className="h-8 w-auto"
                            src="/logo.svg"
                            alt="Logo"
                          />
                        </div>
                        <div className="-mr-2">
                          <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                            <span className="sr-only">Close menu</span>
                            <XIcon className="h-6 w-6" aria-hidden="true" />
                          </Popover.Button>
                        </div>
                      </div>
                      <div className="mt-6">
                        <nav className="grid grid-cols-1 gap-7">
                          {solutions.map((item) => {
                            if (!item.href.startsWith('https://')) {
                              return (
                                <NavLink
                                  activeClassName="text-blue-900"
                                  activeStyle={{ fontWeight: 'bolder' }}
                                  key={item.name}
                                  to={item.href}
                                  className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                                >
                                  <div className="ml-4 text-base font-medium text-gray-900">
                                    {item.name}
                                  </div>
                                </NavLink>
                              );
                            } else {
                              return (
                                <a
                                  key={item.name}
                                  href={item.href}
                                  className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                                >
                                  <div className="ml-4 text-base font-medium text-gray-900">
                                    {item.name}
                                  </div>
                                </a>
                              );
                            }
                          })}
                          {!userInfo && (
                            <Link
                              to="/sign-in"
                              className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                            >
                              <div className="ml-4 text-base font-medium text-gray-900">
                                Candidate
                              </div>
                            </Link>
                          )}
                          {userInfo && (
                            <Link
                              to="/change-password"
                              className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                            >
                              <div className="ml-4 text-base font-medium text-gray-900">
                                Change password
                              </div>
                            </Link>
                          )}
                          {userInfo && (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                onLogout();
                                history.push('/');
                              }}
                              className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                            >
                              <div className="ml-4 text-base font-medium text-gray-900">
                                Sign out
                              </div>
                            </a>
                          )}
                        </nav>
                      </div>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      </header>
      <div style={{ height: `${headerRef?.current?.clientHeight || 110}px` }} />
    </>
  );
}
